import GoogleAdSense from './GoogleAdSense';
import NaverAdComponent from './NaverAdComponent';

export { GoogleAdSense, NaverAdComponent };
